import React from 'react'
import moment from 'moment';
import { Link } from 'react-router-dom';
import df from '../../images/Default_pfp.jpg';

function NotificationCard({ notification }) {
  const senderId = notification?.sender?.id;
  const senderPic = notification?.sender?.personal_details?.profile_picture || df;
  const senderName = notification?.sender?.name || "Admin/System";

  return (
        <li>
            
                <Link to={senderId ? `/profile/${senderId}` : "#"} className="rounded-3 bg-lightblue theme-light-bg">
                 
                  <div className="email-user">
                
                    <img src={senderPic}  alt="user" className="w35 me-2 rounded-circle" style={{aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'center'}} />  
                    <h6 className="font-xssss text-grey-900 text-grey-900 mb-0 mt-0 fw-700">{senderName}</h6>
                  </div>
                  
                  <div className="email-text text-grey-500 fw-600 font-xssss">
                    {notification?.message}
                  </div>
                  <span className="email-file">
                    <i className="feather-bell font-xss btn-round-sm text-grey-500 me-2 p-0" />
                  </span>
                  <div className="email-time text-grey-500 fw-600">{notification?.created_at ? moment(notification.created_at).fromNow() : ""}</div>
                </Link>
              </li>
  )
}

export default NotificationCard